module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f81422"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cameras/Cameras.vue
// module id = 336
// module chunks = 1